import { createContext, ReactNode, useContext } from 'react';

import { TenantBranding } from './types';
import { defaultBranding } from './defaultBranding';

const BrandingContext = createContext<TenantBranding>(defaultBranding);

export function BrandingProvider({ branding, children }: { branding: TenantBranding; children: ReactNode }) {
  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

/** access the resolved tenant branding (logo, tenant name, raw colors) anywhere in the tree */
export function useBranding(): TenantBranding {
  return useContext(BrandingContext);
}
